import { EventFormQuestion } from "@ac-expo/api-types";
import { Control } from "react-hook-form";
import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { FormInput } from "../form/FormInput";
import { Input } from "../Input";
import { Label } from "../Label";

interface EventFormShortTextProps {
  question: EventFormQuestion;
  control?: Control<CreateEventFormAnswersForm>;
  index?: number;
  isReadOnly?: boolean;
}

export default function EventFormShortText({
  question,
  control,
  index,
  isReadOnly = false,
}: EventFormShortTextProps) {
  if (isReadOnly) {
    return (
      <div className="space-y-2">
        <Label className="text-sm text-gray-600">
          {question.theme} : {question.question}
        </Label>
        <Input placeholder="Votre réponse..." className="bg-gray-50" />
      </div>
    );
  }

  if (!control || index === undefined) {
    throw new Error(
      "control and index are required when not in read-only mode"
    );
  }

  return (
    <FormInput
      key={question.id}
      control={control}
      name={`answers.${index}.answer`}
      label={`${question.theme} : ${question.question}`}
      placeholder="Votre réponse..."
      hasMessage
      maxLength={128}
    />
  );
}
